import React, { useState, useCallback, useEffect } from 'react';
import Header from '../../../ContentParts/Header';
import QueryStringBuilder from '../../../querystring.js';
import ChaletSearchResultsInspiration from '../ChaletSearch/ChaletSearchResultsInspiration';
import { Helmet } from 'react-helmet-async';

const InspireMeFamilyFriendly = (props) => {
    const [searchResultsCount, setSearchResultsCount] = useState(0);
    const [resultsVisible, setResultsVisible] = useState(true);
    const [searchQuery, setSearchQuery] = useState(null);

    const handleChildData = useCallback((queryStringParams) => {
        if (searchQuery === null) {
            setSearchQuery(queryStringParams);
        }
    }, [searchQuery]);

    const toggleResultVisability = () => {

        if (resultsVisible) {
            setResultsVisible(!resultsVisible);
        }
    };

    const updateSearchCount = (count) => {
        setSearchResultsCount(prevCount => prevCount === 0 ? count : prevCount + count);
        window.ServerLoading = false;
    };


    useEffect(() => {
        document.title = "Find me a Chalet in a Family Friendly Resort";
        window.ServerLoading = true;
    }, []);




    return (
        <div>
            <Helmet>
                <title>Family-Friendly Ski Chalets in the Alps - Book Your Ski Holiday</title>
                <meta
                    name="description"
                    content="Discover family-friendly ski chalets in the Alps. Safe, fun, and conveniently located near ski schools and snow-sure slopes for all ages."
                />
                <meta name="keywords" content="family ski chalets, Alps family holidays, child-friendly ski holidays, family skiing Alps" />
                <link rel="canonical" href="https://www.chaletaway.com/FamilyFriendly" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "LodgingBusiness",
                        "name": "ChaletAway - Family-Friendly Ski Chalets",
                        "url": "https://www.chaletaway.com/FamilyFriendly",
                        "logo": "https://www.chaletaway.com/Chaletawaylogo.png",
                        "description": "Explore ChaletAway�s collection of family-friendly ski chalets in the Alps. These chalets offer safe and enjoyable stays near ski schools, gentle slopes, and fun activities for all ages.",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "86-90 Paul Street",
                            "addressLocality": "London",
                            "addressRegion": "England",
                            "postalCode": "EC2A 4NE",
                            "addressCountry": "GB"
                        },
                        "offers": [
                            {
                                "@type": "Offer",
                                "name": "Family Ski Chalets",
                                "description": "Stay in family-friendly chalets in the Alps, ideal for children and parents alike with nearby ski schools and amenities.",
                                "url": "https://www.chaletaway.com/FamilyFriendly"
                            },
                            {
                                "@type": "Offer",
                                "name": "Child-Friendly Ski Holidays",
                                "description": "Book child-friendly ski holidays with safe accommodations, ski lessons, and gentle slopes for young skiers.",
                                "url": "https://www.chaletaway.com/FamilyFriendly"
                            },
                            {
                                "@type": "Offer",
                                "name": "Alps Family Holidays",
                                "description": "Perfect for family skiing adventures in the Alps, these chalets offer access to ski areas designed for all ages.",
                                "url": "https://www.chaletaway.com/FamilyFriendly"
                            }
                        ]
                    })}
                </script>
            </Helmet>

            <QueryStringBuilder sendDataToParent={handleChildData} />
            <div></div>
            <Header
                bg_Id="bg_2"
                PageName={`${searchResultsCount} Chalets`}
                toggleResultVisability={toggleResultVisability}
                PageBreadCrumbName={"Search"}
                location={props.location}
            />

            <ChaletSearchResultsInspiration
                resultsVisible={resultsVisible}
                updateSearchCount={updateSearchCount}
                inspireMeAttributeId={4}
            />

        </div>
    );
};

export default InspireMeFamilyFriendly;
